import styled from 'styled-components'

import NavLink from '../../components/NavLink'
import { THEME, COLORS, media, typeScale } from '../../styles'
import LottieAnimation from '../../components/LottieAnimation'

const Styled = styled.main`
  background: ${THEME.COLORS.background.primary};
  padding: 2.4rem;
  text-align: center;
  display: flex;
  min-height: inherit;
  place-content: stretch center;
  flex-flow: column nowrap;
  ${media.medium`
    padding: 3.6rem;
  `}
`
Styled.content = styled.div``
Styled.goBack = styled.p`
  text-align: center;
  padding: 2.4rem;
  ${media.medium`
    padding: 3.6rem;
  `}
`
Styled.goBackLink = styled(NavLink)`
  ${typeScale('button')};
  text-decoration: none;
  background-color: ${COLORS.primary};
  color: ${COLORS.white};
  transition: background-color 0.2s ease-in-out;
  padding: 1.2rem 2.4rem;
  border-radius: 3.6rem;
`
Styled.lottieContainer = styled.div`
  margin: 0 auto;
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  ${media.medium`
    width: 60rem;
    height: 52rem;
  `}
`
Styled.lottie = styled(LottieAnimation)``
Styled.illustration = styled.svg`
  ${typeScale('body')};
  margin: 0 auto;
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  ${media.medium`
    ${typeScale('headline3')};
    width: 60rem;
    height: 52rem;
  `}
`
Styled.notFount = styled.div``
Styled.serverError = styled.div``
Styled.genericError = styled.div``
Styled.fix = styled.p`
  text-align: center;
  padding-top: 1.6rem;
  max-width: 52rem;
  margin: 0 auto;
  display: block;
  ${media.medium`
    padding: 2.4rem;
  `}
`
Styled.label = styled.p`
  ${typeScale('headline3', { fontSize: '1.6rem' })};
  position: absolute;
  bottom: 25%;
  left: 0;
  width: 100%;
  text-align: center;
  color: ${COLORS.black};
  ${media.medium`
    ${typeScale('headline2')};
  `}
`
Styled.retry = styled.div`
  padding: 2.4rem 0;
  ${media.medium`
    padding: 3.6rem 0;
  `}
`
Styled.retryText = styled.p`
  text-align: center;
`
Styled.retryLink = styled(NavLink)`
  text-decoration: none;
  color: ${COLORS.primary};
  font-weight: bold;
`

export default Styled
